type SectionCurveProps = {
  /** Cor da seção de cima (token da escala, ex.: "foreground-950") */
  from: string;
  /** Cor da seção de baixo (token da escala, ex.: "background-50") */
  to: string;
};

/**
 * Divisor curvo entre duas seções de cores diferentes.
 * A seção de baixo ganha um arco suave que sobe na seção de cima,
 * criando uma emenda elegante — sem faixas cinzas no meio.
 * Altura líquida zero: o arco vive dentro do respiro da seção de cima.
 */
export default function SectionCurve({ from, to }: SectionCurveProps) {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none relative z-[1] -mt-14 h-14 w-full md:-mt-20 md:h-20"
      style={{ backgroundColor: `oklch(var(--${from}))` }}
    >
      <div
        className="absolute inset-0"
        style={{
          backgroundColor: `oklch(var(--${to}))`,
          borderTopLeftRadius: "50% 100%",
          borderTopRightRadius: "50% 100%",
          borderTop: "1.5px solid oklch(var(--accent-500))",
        }}
      />
    </div>
  );
}